// extracted by mini-css-extract-plugin
module.exports = {"accordionButton":"accordionButton__2tpmi","icon":"icon__33_1N"};